import React from 'react';
import PropTypes from 'prop-types';
import { TextUtilities } from '@pwc/pwc-deals-web-common';
import { valueAsPercent } from '../../../../../common/services/textService';
import { EMPTY_DATA_MARKER } from '../../../../../common/engine/utilities/constants';
import AdjustmentControlsColumn from '../../common/AdjustmentControlsColumn';

const displayAsPercent = (value, emptyDataMarker) =>
  value ? valueAsPercent(value) : emptyDataMarker;

const PercentageRow = ({
  rowText,
  financials,
  timePeriods,
  emptyDataMarker,
  isPublishMode,
}) => {
  return (
    <tr
      role="row"
      className="percent-of-revenue"
      data-testid={`percent-of-${TextUtilities.slugify(rowText)}`}
    >
      <th role="rowheader" scope="row" className="row-description">
        {`As a % of ${rowText}`}
      </th>

      {timePeriods.map((value, index) => (
        <td
          data-testid={`percent-of-${TextUtilities.slugify(
            rowText
          )}-column-value`}
          // eslint-disable-next-line react/no-array-index-key
          key={`PercentageRowColumnValue-${value}-${index}`}
          role="cell"
          className="financial-value"
        >
          {displayAsPercent(financials[value], emptyDataMarker)}
        </td>
      ))}

      {!isPublishMode && <AdjustmentControlsColumn />}
    </tr>
  );
};

PercentageRow.propTypes = {
  rowText: PropTypes.string.isRequired,
  financials: PropTypes.shape({}).isRequired,
  timePeriods: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  ).isRequired,
  emptyDataMarker: PropTypes.string,
  isPublishMode: PropTypes.bool,
};

PercentageRow.defaultProps = {
  emptyDataMarker: EMPTY_DATA_MARKER,
  isPublishMode: false,
};

export default PercentageRow;
